import { FinanceFilterNS } from "../models/finance-filter.model";

export const ObjectNames = {
  FinanceConstants: {
    filters: [
      { label: "All Finance", code: 'allwarehouses' },
      { label: "My Finance", code: 'mywarehouses' },
      { label: "New last week", code: 'newlastweek' },
      { label: "New this week", code: 'newthisweek' },
      { label: "New this month", code: 'newthismonth' },
      { label: "Recently Viewed", code: 'recentlyviewedwarehouses' }
    ]

  }
}

export const DateRanges = [
  { "id": 1, name: "Today", code: "today" },
  { "id": 2, name: "Yesterday", code: "yesterday" },
  { "id": 3, name: "This month", code: "this month" },
  { "id": 4, name: "Last month", code: "last month" },
  { "id": 5, name: "Last 7 days", code: "last 7 days" },
  { "id": 6, name: "Last 15 days", code: "last 15 days" },
  { "id": 7, name: "Last 30 days", code: "last 30 days" },
  { "id": 8, name: "Last 60 days", code: "last 60 days" },
  { "id": 9, name: "Last 90 days", code: "last 90 days" },
  { "id": 10, name: "This Year", code: "this year" },
  { "id": 11, name: "Custom", code: "custom" },
];

export const ChartsOfAccountsRecentItems = [
  { label: "All Finance", code: 'allfinancialaccounts' },
  { label: "My Finance", code: 'myfinancialaccounts' },
  { label: "New last week", code: 'newlastweek' },
  { label: "New this week", code: 'newthisweek' },
  { label: "New this month", code: 'newthismonth' },
  { label: "Recently Viewed", code: 'recentlyviewedfinancialaccounts' }
];

export const JournalByNameCols = [
  { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false },
  { field: 'accountName', header: 'Account Name', show: true, value: '', checked: true, order: false },
];

export const JournalUserType = [
  { id: 1, name: 'Customer', code: 'CS' },
  { id: 2, name: 'Vendor', code: 'VD' },
  { id: 3, name: 'Employee', code: 'EM' },
  { id: 4, name: 'Other', code: 'OT' },
];

export const FinanceByNameCols = [
  { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false },
  { field: 'name', header: 'Name', show: true, value: '', checked: true, order: false },
];

export const FinanceChannels = [
  { "id": "1", "name": "Chart of Accounts" },
  { "id": "2", "name": "Journals" },
  { "id": "3", "name": "General Ledger" },
  { "id": "4", "name": "Trial Balance" },
];

export enum FinanceChannelName {
  ChartofAccounts = "Chart of Accounts",
  Journals = "Journals",
}

export const FinanceCols2 = [
  { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false },
  { field: 'name', header: 'Name', show: true, value: '', checked: true, order: false },
  { field: 'group', header: 'Group', show: true, value: '', checked: true, order: false },
  { field: 'balance', header: 'Balance Total', show: true, value: '', checked: true, order: false },
  { field: 'action', header: 'Action', show: true, value: '', checked: true, order: false },
];

export const FinanceCols = [
  { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false },
  { field: 'name', header: 'Name', show: true, value: '', checked: true, order: false },
  { field: 'statement', header: 'Financial Statement', show: true, value: '', checked: true, order: false },
  { field: 'group', header: 'Type', show: true, value: '', checked: true, order: false },
  { field: 'balance', header: 'Balance Total', show: true, value: '', checked: true, order: false },
  { field: 'isDefault', header: 'Is Default', show: true, value: '', checked: true, order: false },
  { field: 'action', header: 'Action', show: true, value: '', checked: true, order: false },
];

export const FinancialTransactionDetailCols = [
  {
    field: 'transactionDate', header: 'Transaction Date', show: true, value: '', checked: true, order: false, dataType: "date"
  },
  { field: 'businessName', header: 'Business Name', show: true, value: '', checked: true, order: false, dataType: "string" },
  { field: 'financialAccountName', header: 'Financial Account Name', show: true, value: '', checked: true, order: false, dataType: "string" },
  { field: 'classification', header: 'Account Classification', show: true, value: '', checked: true, order: false, dataType: "string" },
  { field: 'memo', header: 'Memo', show: true, value: '', checked: true, order: false, dataType: "string" },
  { field: 'transactionName', header: 'Transaction Name', show: true, value: '', checked: true, order: false, dataType: "string" },
  { field: 'debit', header: 'Debit', show: true, value: '', checked: true, order: false, dataType: "number" },
  { field: 'credit', header: 'Credit', show: true, value: '', checked: true, order: false, dataType: "number" },
  { field: 'balance', header: 'Balance', show: true, value: '', checked: true, order: false, dataType: "number" },
];

export const JournalCols = [
  { field: 'id', header: 'ID', name: 'ID', show: false, value: '', checked: false, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'id' },
  { field: 'txnNumber', header: 'Txn Id', name: 'Tranx Id', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'txnNumber' },
  { field: 'transactionName', header: 'Transaction Name', name: 'Transaction Name', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'transactionName' },
  { field: 'transactionDate', header: 'Txn Date', name: 'Txn Date', show: true, value: '', checked: true, order: false, dataType: "DateTime", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "DateTime").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "DateTime", columnName: 'transactionDate' },
  { field: 'postingDate', header: 'Posting Period', name: 'Posting Period', show: false, value: '', checked: true, order: false, dataType: "DateTime", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "DateTime").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "DateTime", columnName: 'postingDate' },
  { field: 'referenceNumber', header: 'Ref. No', name: 'Ref. No', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'referenceNumber' },
  { field: 'businessName', header: 'Account Name', name: 'Account Name', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'businessName' },
  { field: 'financialAccountName', header: 'Finance Account Type', name: 'Finance Account Type', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'financialAccountName' },
  { field: 'financialAccountGroup', header: 'Finance Account Group', name: 'Finance Account Group', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'financialAccountGroup' },
  { field: 'debit', header: 'Debit', name: 'Debit', show: true, value: '', checked: true, order: false, dataType: "Number", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "Money").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "Number", columnName: 'debit' },
  { field: 'credit', header: 'Credit', name: 'Credit', show: true, value: '', checked: true, order: false, dataType: "Number", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "Money").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "Number", columnName: 'credit' },
];

export const GeneralLedgerCols = [
  { field: 'financialAccountName', header: 'Financial Account', show: true, value: '', checked: true, order: false, dataType: "string" },
  { field: 'openBalance', header: 'Opening Balance', show: true, value: '', checked: true, order: false, dataType: "number" },
  { field: 'totalDebit', header: 'Total Debit', show: true, value: '', checked: true, order: false, dataType: "number" },
  { field: 'totalCredit', header: 'Total Credit', show: true, value: '', checked: true, order: false, dataType: "number" },
  { field: 'endingBalance', header: 'Ending Balance', show: true, value: '', checked: true, order: false, dataType: "number" },
];

export const TrialBalanceCols = [
  { field: 'financialAccountName', header: 'Financial Account', show: true, value: '', checked: true, order: false, dataType: "string" },
  { field: 'debit', header: 'Total Debit', show: true, value: '', checked: true, order: false, dataType: "number" },
  { field: 'credit', header: 'Total Credit', show: true, value: '', checked: true, order: false, dataType: "number" },
];

export const ReconcilationReportCols = [
  { field: 'type', header: 'Type', name: 'Type', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'reconciliationReportType' },
  { field: 'createDate', header: 'Date', name: 'Date', show: true, value: '', checked: true, order: false, dataType: "DateTime", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "DateTime").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "DateTime", columnName: 'createDate' },
  { field: 'num', header: 'Ref. No', name: 'Ref. No', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'num' },
  { field: 'name', header: 'Name', name: 'Name', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'businessName' },
  { field: 'amount', header: 'Amount', name: 'Amount', show: true, value: '', checked: true, order: false, dataType: "Number", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "Money").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "Number", columnName: 'reconciliationReportAmount' },
  { field: 'balance', header: 'Balance', name: 'Balance', show: true, value: '', checked: true, order: false, dataType: "Number", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "Money").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "Number", columnName: 'reconciliationReportBalance' },
];

export const JournalFilterColumns = {
  txnNumber: "txnNumber",
  transactionName: "txnname",
  transactionDate: "date",
  referenceNumber: "referenceNumber",
  businessName: "accountname",
  financialAccountName: "type",
  financialAccountGroup: "group",
  debit: "debit",
  credit: "credit",
}

export enum SearchColumns {
  AccountsSearchColumns = "name,group",
  JournalsSearchColumns = "txnNumber,txnname,date,referenceNumber,accountname,type,group,debit,credit",
  AccountsTransactionSearchColumns = "date,accountname,type,group,txnname,debit,credit,classification",
}

export enum AddEditDialogType {
  Add = "ADD",
  Edit = "EDIT",
  View = "VIEW",
}

export enum AccountsTransactionType {
  Invoice = 1,
  ReceivePayment = 2,
  CreditMemo = 3,
  ItemReceipt = 4,
  BillPay = 5,
  BillCredit = 6,
  Deposit = 7,
  JournalEntry = 8,
  Expense = 9,
  InventoryAdjustment = 10,
  BankRegister = 11,
  BillExpense = 12,
  BillExpensePay = 13,
  BillOfMaterial = 14,
  WorkOrder = 15,
  InventoryTransfer = 16,
  PurchaseOrder = 17,
  SalesOrder = 18,
  Estimate = 19,
  Bill = 20,
  Check = 21,
  Reconcile = 22,
  FundTransfer = 23,
  CreditCharges = 24,
  CustomerRMA = 25,
  VendorRMA = 26,
  VendorCredit = 27
}

export enum TransactionNames {
  InventoryAdjustment = "Inventory Adjustment",
  InventoryTransfer = "Inventory Transfer",
  Invoice = "Invoice",
  Estimate = "Estimate",
  SalesOrder = "SalesOrder",
  CreditMemo = "Credit Memo",
  PurchaseOrder = "PurchaseOrder",
  ItemReceipt = "Item Receipt",
  Bill = "Bill",
  BillPayment = "Payment Receipt",
  ReceivePayment = "ReceivePayment",
  JournalEntry = "Journal Entry",
  BankRegister = "Bank Register",
  FundTransfer = "FundTransfer",
  Deposit = "Deposit",
  Check = "Check",
  Expense = "Expense",
  CreditCharges = "CreditCharges",
  CustomerRMA = "CustomerRMA",
  VendorRMA = "VendorRMA",
  VendorCredit = "VendorCredit",
  Reconcile = "Reconcile",
  ReconcileCreditCard = "ReconcileCreditCard",
}

export enum Channel {
  Estimate = "2",
  SalesOrder = "3",
  Invoice = "4",
  CustomerRMA = "5",
  CreditMemo = "6",
  PurchaseOrder = "1",
  ItemReceipt = "2",
  Bill = "3",
  BillPayment = "4",
  VendorRMA = "6",
  VendorCredit = "7"
}

export enum RoutingPath {
  Estimate = "estimates",
  SalesOrder = "sales-order",
  Invoice = "invoicing",
  CreditMemo = "credit-memo",
  PurchaseOrder = "purchase-order",
  ItemReceipt = "item-receipt",
  Bill = "bill",
  BillPayment = "payment-receipt",
  CustomerRMA = "customer-returns"
}

export enum FinancialAccountTypeNumber {
  Income = 20000,
  COGS = 60000,
  Expense = 40000,
}

export enum ReportType {
  Profitandloss = "profitandloss",
  Profitandlossdetaill = "profitandlossdetaill",
  Generalledger = "generalledger",
  Generalledgerdetail = "generalledgerdetail",
  Trailbalance = "trailbalance",
  Trailbalancedetail = "trailbalancedetail",
  Balancesheet = "balancesheet",
  Balancesheetdetail = "balancesheetdetail",
  Chartofaccountdetail = "chartofaccountdetail",
}

export const OrderOptions = [
  { name: 'ASC', value: 'asc' },
  { name: 'DESC', value: 'desc' },
];

export const LOCK_MODULES = {
  lockAP: [TransactionNames.ItemReceipt, TransactionNames.Bill, TransactionNames.BillPayment, TransactionNames.VendorCredit, TransactionNames.VendorRMA],
  lockAR: [TransactionNames.Invoice, TransactionNames.ReceivePayment, TransactionNames.CreditMemo, TransactionNames.CustomerRMA],
  lockGL: [TransactionNames.JournalEntry, TransactionNames.Check, TransactionNames.Expense, TransactionNames.Deposit, TransactionNames.FundTransfer, TransactionNames.Reconcile, TransactionNames.BankRegister, TransactionNames.CreditCharges, TransactionNames.ReconcileCreditCard, TransactionNames.InventoryAdjustment, TransactionNames.InventoryTransfer],
  excludeOthers: [TransactionNames.SalesOrder, TransactionNames.Estimate, TransactionNames.PurchaseOrder],
  // excludeOthers :[so,po,esti] false means block,true means allow and  no response that time also allow. 
}

export enum PayTo {
  Vendor = "vendor",
  Customer = "customer",
  Employee = "employee",
  Other = "other",
}

export enum UserType {
  Vendor = "Vendor",
  Customer = "Customer",
  Other = "Other",
  Employee = "Employee",
}

export type typeJournalAddEditText = 'Save' | 'SaveAndNew' | 'Edit';
export type typeJournalDebitCreditCalculation = 'New' | 'Existing' | 'Delete' | null;

export type typeFinanceAddEditViewText = 'ADD' | 'EDIT' | 'VIEW' | "" | null;

export const maxChildLevelForChartOfAccountsCreate = 2;
export const maxChildLevelForChartOfAccountsView = 4;

export const ReconciliationReportParentId = [1, 2, 3, 4, 5, 6];



export const AccountSelectableColumns = [
  {
    "columnName": "sequenceNumber",
    "isCustom": false
  },
  {
    "columnName": "businessName",
    "isCustom": false
  },
  {
    "columnName": "mainCustomer",
    "isCustom": false
  },
  {
    "columnName": "accountTypesName",
    "isCustom": false
  },
  {
    "columnName": "accountNumber",
    "isCustom": false
  },
  {
    "columnName": "channelId",
    "isCustom": false
  },
  {
    "columnName": "parentAccountSequenceNumber",
    "isCustom": false
  }
];


export const ChildAccountSelectableColumns = [
  {
    "columnName": "sequenceNumber",
    "isCustom": false
  },
  {
    "columnName": "businessName",
    "isCustom": false
  },
  {
    "columnName": "mainCustomer",
    "isCustom": false
  },
  {
    "columnName": "accountTypesName",
    "isCustom": false
  },
  {
    "columnName": "accountNumber",
    "isCustom": false
  },
  {
    "columnName": "contactFirstName",
    "isCustom": false
  },
  {
    "columnName": "state",
    "isCustom": false
  },
  {
    "columnName": "NoOfUnreadLogs",
    "isCustom": false
  },
  {
    "columnName": "stageId",
    "isCustom": false
  },
  {
    "columnName": "leadId",
    "isCustom": false
  },
  {
    "columnName": "NoOfTask",
    "isCustom": false
  },
  {
    "columnName": "ReminderCount",
    "isCustom": false
  },
  {
    "columnName": "NoOfAttachment",
    "isCustom": false
  },
  {
    "columnName": "channelId",
    "isCustom": false
  },
  {
    "columnName": "parentAccountSequenceNumber",
    "isCustom": false
  }
]